import { getThumbnailUrl, getVideoUrl } from "./../_shared/url-resolvers.js";
const commonDefaults = {
  getVideoUrl,
  getThumbnailUrl
};
const DEFAULT_CONFIGS = {
  editor: {
    toolbar: {
      hidden: []
    },
    ...commonDefaults
  },
  viewer: {
    ...commonDefaults
  }
};
export {
  DEFAULT_CONFIGS
};
//# sourceMappingURL=defaults.js.map
